import { AppBar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Icon, IconButton, Stack, TextField, Toolbar, Typography } from "@mui/material";
import React from "react";
import AgGridTable from "../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useState, useEffect } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import UtilizedView from "./UtilizedView";

const LCStatusList = (props) => {
    const [openTopUp, setOpenTopUp] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [successMsg, setSuccessMsg] = useState();
    const [acceptId, setAcceptId] = useState();
    const [snackState, setSnackState] = useState(false);
    const [openAccepted, setOpenAccepted] = useState(false)
    const [penddingView, setPenddingView] = useState(false)
    const [viewId, setViewId] = useState()
    const [openView, setOpenView] = useState(false)
    const [error, setError] = useState("");
    const [pendingData, setPendingData] = useState({
        company: '',
        companyName: '',
        documentCreditNo: ''
    })

    const handleActions = (params) => {
        return params.data && <>
            <IconButton size="small" className="p-0"><Icon className="p-0" onClick={() => hanleViewUtilized(params.data.id)}>visibility</Icon></IconButton>
            {props.pendingStatus === 'Pending' && <IconButton size="small" className="p-0" onClick={() => handleAccepted(params.data.id)}><Icon fontSize="2rem" className="p-0">check</Icon></IconButton>}
            {props.pendingStatus === 'Accepted' && <IconButton size="small" className="p-0" onClick={() => handleLCDiscount(params.data.id)}><FuseSvgIcon size={18}>feather:percent</FuseSvgIcon></IconButton>}
        </>
    }

    const renderCurrency = (props) => {
        return <span style={{ display: "flex" }}>
            <p>{new Intl.NumberFormat('en-US').format(props?.value)}</p>
        </span>;
    };

    const [columnDefs, setColumnDefs] = useState([
        { field: 'bankRefNo' },
        { field: 'doc_date', headerName: 'Doc Date' },
        { field: 'docNo' },
        { field: 'totalAmount',cellRenderer:renderCurrency},
        { field: 'blDate' },
        { field: 'action', headerName: 'Action', cellRenderer: handleActions },
    ]);
    const lcUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.lcDocument}`;

    const handleClose = () => {
        setOpenTopUp(false)
        setOpenAccepted(false)
        props.handleStatusClose()
    }

    const handleAccepted = (id) => {
        setAcceptId(id)
        setOpenAccepted(true)        
    }

    const hanleViewUtilized = (id) => {
        setViewId(id)
        setOpenView(true)
    }

    const closeOpenLCTopup = () => {
        setOpenView(false);
        setPenddingView(false)
    }

    const handleLCDiscount = async (id) => {
        const document = await OAuthService.getPdf(lcUrl + `/discount?lcDocumentId=${id}`);

        const file = new Blob([document?.data], {
            type: 'application/pdf',
        });

        const fileURL = URL.createObjectURL(file);
        window.open(fileURL)
    }

    const loadPendingData = async () => {
        let letterOfCredit = props.lcId
        let status = props.pendingStatus
        let data = { letterOfCredit, status }
        const list = await OAuthService.getPostList(lcUrl + `/getAllLcDocuments`, data);
        if (list.data) {
            const listData = list.data.map((data) => {
                if (data.listOfOrder && data.listOfOrder.length > 0) {
                    data.blDate = data.listOfOrder[0].blDate
                }
                return data
            })
            setRowData(listData)
            list.data.length > 0 && setPendingData({
                company: list.data[0].letterOfCredit.company,
                companyName: list.data[0].letterOfCredit.companyName,
                documentCreditNo: list.data[0].letterOfCredit.documentCreditNo
            })
        }
    }

    useEffect(() => {
        loadPendingData()
    }, [])

    const handleAcceptedLC = async () => {
        try {
            const list = await OAuthService.getList(lcUrl + `/accept?lcDocumentId=${acceptId}`);
            setSuccessMsg('LC-Document accepted successfully.')
            loadPendingData()
            setOpenAccepted(false);
            setOpenTopUp(false)
        }
        catch (error) {
            setError(error?.response?.data?.errorMessage || error.message);
            setSuccessMsg('');
        }
    }

    useEffect(() => {
        props.successMsg(successMsg)
    }, [successMsg]);

    return (
        <>
            <Dialog
                fullWidth={true}
                maxWidth={'md'}
                onClose={handleClose}
                open={openTopUp}
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full justify-between">
                        <Typography variant="subtitle1" color="inherit">
                        {props.pendingStatus} List
                        </Typography>
                        <Button onClick={handleClose}>
                            <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
                        </Button>
                    </Toolbar>
                </AppBar>
                <DialogContent dividers>
                    <Grid container spacing={2} className="mt-8">
                        <Grid item xs={8}>
                            <Stack>
                                <lable>Client Name</lable>
                                <TextField
                                    value={pendingData.companyName}
                                    name="customer"
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                value={pendingData.company}
                                name="customer"
                                disabled
                                inputProps={{
                                    sx: { 'padding': '10px' },
                                }}
                                style={{ marginTop: "2rem" }}

                            />
                        </Grid>
                    </Grid>
                    <Grid container className="mt-8" >
                        <Grid item xs={12}>
                            <Stack>
                                <lable>Documentary Credit No</lable>
                                <TextField
                                    value={pendingData.documentCreditNo}
                                    // name="customer"
                                    disabled
                                    inputProps={{
                                        sx: { 'padding': '10px' },
                                    }}

                                />
                            </Stack>
                        </Grid>
                    </Grid>
                    <Divider />
                    <div className="mt-8 h-[300px]" >
                        <AgGridTable
                            rowData={rowData}
                            columnDefs={columnDefs}
                        // onGridReady={onGridReady}
                        />
                         <div className="flex justify-end items-baseline mt-8">
                            <label className="mr-8" >Total Selected</label>
                            <TextField
                                name="total"
                                value={rowData?.reduce((total, row) => total + row.totalAmount, 0)}
                                disabled
                                inputProps={{
                                    sx: { 'width': '80px', 'height': '5px' },
                                }} />
                        </div>
                    </div>
                </DialogContent>
            </Dialog>

            <Dialog
                open={openAccepted}
                onClose={handleClose}
                maxWidth={'sm'}
                PaperProps={{
                    sx: {
                        height: 150,
                        width: 250
                    }
                }}

                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Document Accepted ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAcceptedLC}>Confirm</Button>
                    <Button onClick={handleClose} autoFocus>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            {(openView || penddingView) && <UtilizedView open={openView} id={viewId} handleClose={closeOpenLCTopup} ViewOptions={openView ? "UtilizeView" : penddingView ? 'PendingView' : ''} />}
        </>
    )
}
export default LCStatusList